import React, {
  FC,
  RefObject,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import SearchInputControlled from "components/SearchInput/SearchInputControlled";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useClickAwayListener } from "../../../../../hooks/useClickAwayListener";
import { СhooseAdditionalFormValues } from "../../ChooseForms/ChooseAdditionalForm/chooseAdditionalFormHelper";
import SideAddonInfoItem from "./SideAddonInfoItem/SideAddonInfoItem";
import { MainWrapper, ScrollableWrapper } from "./SideAddonsInfo.styles";

interface SideAddonsInfoProps {
  addons: any;
  cartItems: any;
  onActiveItemChange: (data: any) => void;
  values: СhooseAdditionalFormValues;
  activeItem: { value: string; label: string };
  activeSectionRef: RefObject<HTMLFormElement>;
}

const SideAddonsInfo: FC<SideAddonsInfoProps> = ({
  values,
  addons,
  cartItems,
  activeItem,
  onActiveItemChange,
  activeSectionRef,
}) => {
  const { t } = useTranslation("common");
  const [searchTerm, setSearchTerm] = useState("");
  const wrapperRef = useRef(null);

  const handleClickAway = () => {
    handleClearSelection();
  };

  useClickAwayListener([wrapperRef, activeSectionRef], handleClickAway);

  const filteredItems =
    searchTerm && searchTerm !== ""
      ? cartItems.filter((item: any) =>
          item
            .get("shipment_tracking_number")
            .toLowerCase()
            .includes(searchTerm.toLowerCase()),
        )
      : cartItems;

  const handleClearSelection = useCallback(() => {
    onActiveItemChange({ value: "all" });
  }, [onActiveItemChange]);

  const listenKeyboard = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Escape" || event.keyCode === 27)
        handleClearSelection();
    },
    [handleClearSelection],
  );

  const handleSearchTerm = useCallback(
    (value: string) => {
      setSearchTerm(value);
    },
    [setSearchTerm],
  );

  useEffect(() => {
    window.addEventListener("keydown", listenKeyboard, true);

    return () => {
      window.removeEventListener("keydown", listenKeyboard, true);
    };
  }, [listenKeyboard]);

  return (
    <MainWrapper ref={wrapperRef}>
      <SearchInputControlled
        name="trackingNumber"
        initialValue={""}
        value={searchTerm}
        placeholder={t("parcels.search.filterByTrackingNumber")}
        onChange={handleSearchTerm}
      />
      <ScrollableWrapper autoHeight autoHeightMax={isMobile ? 220 : 520}>
        {filteredItems.map((cartItem: any) => (
          <SideAddonInfoItem
            key={cartItem.get("id")}
            addons={addons}
            itemAddons={values[cartItem.get("id") as keyof typeof values]}
            cartItem={cartItem}
            activeItem={activeItem}
            onActiveItemChange={onActiveItemChange}
          />
        ))}
      </ScrollableWrapper>
    </MainWrapper>
  );
};

export default React.memo(SideAddonsInfo);
